import { getPlaceAuthorities } from "./authorities"

export const readPlace = defineAbility((user) => {
  const authorities = getPlaceAuthorities(user)
  return authorities.includes("PLACE_READ")
})

export const editPlace = defineAbility((user) => {
  const authorities = getPlaceAuthorities(user)
  return authorities.includes("PLACE_EDIT")
})

export const createPlace = defineAbility((user) => {
  const authorities = getPlaceAuthorities(user)
  return authorities.includes("PLACE_CREATE")
})

export const archivePlace = defineAbility((user) => {
  const authorities = getPlaceAuthorities(user)
  return authorities.includes("PLACE_DELETE")
})
